<template>
  <div v-if="options_loaded && passed_filter && panel_required" :id="'radio--' + component_id" data-designer-component-id="cut_to_size">
    <div class="designeroption">
      <h3>
        Cut To Size
      </h3>
      <div class="stylesoption" v-if="!loading" style="display: flex; flex-wrap: wrap;">
        <div class="mr-3" :class="[target == option.value ? 'active' : '']" v-for="option in filtered_option_list">
          <label>
            <input type="radio" v-model="localTarget"
                   :name="'radio_' + component_id"
                   :value="option.value"/>
            {{ option.label }}
          </label>
        </div>
      </div>
      <div v-if="loading">
        <p>Loading Options</p>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
    import RadioQuestion from "../mixin/RadioQuestion.vue";

    export default {
        mixins: [
            RadioQuestion
        ],
        props: {
            panelCategory: {
              required: true,
            },
        },
        computed: {
            url() {
                return '/api/options/' + this.fabricator + '/cut-to-size?panel_category=' + this.panelCategory;
            },
            cache_key(){
                return '_cut_to_size' + '_' + this.panelCategory;
            },
            panel_required() {
              return this.filtered_option_list.length > 1;
            },
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
        },
        methods: {
          select_first() {
            // we dont need it, blocking off parent
          }
        }
    }
</script>
